import { render, staticRenderFns } from "./ReportSorting.vue?vue&type=template&id=110fd089&scoped=true"
import script from "./ReportSorting.vue?vue&type=script&lang=js"
export * from "./ReportSorting.vue?vue&type=script&lang=js"
import style0 from "./ReportSorting.vue?vue&type=style&index=0&id=110fd089&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110fd089",
  null
  
)

export default component.exports